export default "__VITE_ASSET__35733505__"